import React from 'react';
import SelectCompressionMode from './SelectCompressionMode';
import HomeUpload from './HomeUpload';
import DownloadZip from './DownloadZip';

const ActionBar = () => {
	return (
		<div className="action-bar">
			<div className="action-bar-groups">
				<div className="action-group">
					<SelectCompressionMode width={170} />
				</div>
				<div className="action-group">
					<div className="action-name">Upload</div>
					<HomeUpload size="default" />
				</div>
				<div className="action-group download-zip">
					<DownloadZip />
				</div>
			</div>
		</div>
	);
};

export default ActionBar;



// WEBPACK FOOTER //
// ./src/components/ActionBar.js